import {WorkflowTargetModel} from "../workflow/models/workflow-target.model";

export interface SiteModel extends WorkflowTargetModel {
  id?: string;
  name?: string;
  k2Name?: string;
  projectId?: string;
  projectName?: string;
  estimatedStartDate?: string;
  estimatedCompleteDate?: string;
  siteCode?: string;
  approvedDate?: string;
  hardwareOrderDate?: string;
  deliveryDate?: string;
  installDate?: string;
  submissionDate?: string;
  completionDate?: string;
  eotLeaseDate?: string;
  sourceName?: string;
  sourceDocumentationLink?: string;
  partnerPurchaseOrders?: any;
  defaultAreaGroup?: string;
  isMigrationActive?: boolean;
}

function parseDateFromJSON(date) {
  if (!date) return "";
  const matches = `${date}`.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})T?/i);
  if (!matches) return "";
  return matches[1] || "";
}

export function siteModelFactory(json?: any): SiteModel {
  json = json || {};
  return {
    id: json.id,
    name: json.name || "",
    k2Name: json.k2Name || "",
    projectId: json.projectId || json.project_id,
    projectName: json.projectName || "",
    estimatedStartDate: parseDateFromJSON(json.estimatedStartDate),
    estimatedCompleteDate: parseDateFromJSON(json.estimatedCompleteDate),
    siteCode: json.siteCode || "",
    approvedDate: parseDateFromJSON(json.approvedDate),
    hardwareOrderDate: parseDateFromJSON(json.hardwareOrderDate),
    deliveryDate: parseDateFromJSON(json.deliveryDate),
    installDate: parseDateFromJSON(json.installDate),
    submissionDate: parseDateFromJSON(json.submissionDate),
    completionDate: parseDateFromJSON(json.completionDate),
    eotLeaseDate: parseDateFromJSON(json.eotLeaseDate),
    sourceName: json.sourceName || "",
    sourceDocumentationLink: json.sourceDocumentationLink || "",
    partnerPurchaseOrders: json.partnerPurchaseOrders || [],
    defaultAreaGroup: json.defaultAreaGroup || "",
    isMigrationActive: json.isMigrationActive,
  } as SiteModel;
}

export function siteModelListFactory(json?: any) {
  return Array.from(json || []).map(site => siteModelFactory(site));
}
